"use strict";

exports.__esModule = true;
exports.MONOSPACE_ELEMENTS = exports.HEADING_ELEMENTS = exports.FONT_WEIGHT = exports.APPEARANCE = exports.ALIGN = void 0;
var ALIGN = {
  start: 'start',
  end: 'end',
  center: 'center',
  justify: 'justify'
};
exports.ALIGN = ALIGN;
var APPEARANCE = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  mouse: 'mouse',
  p: 'p',
  prose: 'prose'
};
exports.APPEARANCE = APPEARANCE;
var FONT_WEIGHT = {
  regular: 'regular',
  semiBold: 'semiBold',
  bold: 'bold',
  extraBold: 'extraBold'
};
exports.FONT_WEIGHT = FONT_WEIGHT;
var HEADING_ELEMENTS = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
exports.HEADING_ELEMENTS = HEADING_ELEMENTS;
var MONOSPACE_ELEMENTS = ['code', 'kbd', 'pre', 'samp'];
exports.MONOSPACE_ELEMENTS = MONOSPACE_ELEMENTS;